import {IoLogoWhatsapp} from 'react-icons/io'
import {AiFillBehanceCircle} from 'react-icons/ai'
import {AiFillTwitterCircle} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'

const data = [
    {id:1, link:'https://wa.me/+254790552354',icon :<IoLogoWhatsapp/>},
    {id:2, link:'https://www.behance.net/joshuaandy',icon :<AiFillBehanceCircle/>},
    {id:3, link:'https://twitter.com/AndyOpote?t=ZXDYqVo3rUAo-fQ06voX5w&s=09',icon :<AiFillTwitterCircle/>},
    {id:4, link:'https://github.com/Andy3643',icon :<AiFillGithub/>}
]
 
export default data